export default __webpack_public_path__ + "static/media/analytics-logo-white.7f653702.png";